import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-candidat-profil',
  templateUrl: './candidat-profil.component.html',
  styleUrl: './candidat-profil.component.scss',
})
export class CandidatProfilComponent {
  title: string;
  condidat: any[] = [
    {
      name: 'Mme. Mathilde Lefevre',
      status: 1,
      img: '/assets/images/user.png',
    },
    { name: 'Mr. Alexandre Lambert', status: 1 },
    {
      name: 'Mme. Charlotte Rousseau',
      status: 0,
      img: '/assets/images/user1.png',
    },
    { name: '{candidat.name}', status: 0 },
    {
      name: 'Mr. Lambert Alexandre',
      status: 0,
      img: '/assets/images/user2.png',
    },
    { name: 'Mme. Mathilde Lefevre', status: 1 },
    {
      name: 'Mr. Alexandre Lambert',
      status: 1,
      img: '/assets/images/user1.png',
    },
    { name: 'Mme. Charlotte Rousseau', status: 0 },
    { name: '{candidat.name}', status: 0 },
    {
      name: 'Mr. Lambert Alexandre',
      status: 0,
      img: '/assets/images/user1.png',
    },
    { name: 'Mme. Mathilde Lefevre', status: 1 },
    {
      name: 'Mr. Alexandre Lambert',
      status: 1,
      img: '/assets/images/user2.png',
    },
    {
      name: 'Mme. Charlotte Rousseau',
      status: 0,
      img: '/assets/images/user2.png',
    },
    { name: '{candidat.name}', status: 0, img: '/assets/images/user1.png' },
    {
      name: 'Mr. Lambert Alexandre',
      status: 0,
      img: '/assets/images/user1.png',
    },
  ];
  condidatAccepted: any[];
  condidatFilted: any[];
  rowData: any;
  constructor(
    public dialogRef: MatDialogRef<CandidatProfilComponent>,
    @Inject(MAT_DIALOG_DATA) private data: any
  ) {
    this.rowData = data;
  }

  ngOnInit(): void {
    this.condidatAccepted = this.condidat.filter((el) => el.status != 0);
    this.condidatFilted = this.condidat.filter((el) => el.status != 1);
    this.title = this.data.titre;
    this.rowData = this.data;
  }
  onDialogClose(): void {
    this.dialogRef.close(this.data);
  }
  rating(rate: number) {}
}
